import React from 'react'
import { navigate } from 'gatsby'
import classnames from 'classnames'

import Logo from '../../svg/logo.svg'
import Hamburger from '../../svg/menu.svg'

import '../../scss/header.scss'
import '../../scss/header-sticky.scss'

const HeaderHeight = 114

export default class Header extends React.Component {

    defaultProps = {
        language: 'nl'
    }

    state = {
        mobileMenuOpen: false,
        top: 0,
        max: HeaderHeight,
        isTouch: true
    }

    componentDidMount() {
        // if the page itself has sticky element
        // then the header should behave non sticky
        if (this.props.hasStickyElement) return

        this.scroll()
        window.addEventListener('scroll', this.scroll , true);
        this.setState({
            isTouch: 'ontouchstart' in document.documentElement
        })
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.scroll, true);
    }

    scroll = () => {

        const { max } = this.state

        const top = window.pageYOffset || document.documentElement.scrollTop

        let newMax = 0

        // wichever is higher
        newMax = Math.max(top, max)

        // max should never be greater than top +
        newMax = (top + HeaderHeight) < newMax ? top + HeaderHeight : newMax

        // max should never be smaller than HeaderHeight
        newMax = Math.max(newMax, HeaderHeight)

        this.setState({
            top,
            max: newMax
        })
    }

    render () {

        const { hasStickyElement, language } = this.props

        const { mobileMenuOpen, top, max, isTouch } = this.state

        const isSticky = !isTouch && !hasStickyElement

        return (
            <React.Fragment>
                <section
                    className={classnames('header-bar', 'storelocator', { 'mobile-menu-open': mobileMenuOpen, sticky: isSticky })}
                    style={{
                        top: isSticky && Math.min(max - top - 114, 0)
                    }}
                >
                    <div className="header">

                        <div className="home">
                            <Logo />
                        </div>

                        <div className="menu">
                            <ul>
                                <li>
                                    <select className="language" value={language} onChange={ev => navigate(`/${ev.target.value}/storelocator`)}>
                                        <option value="nl">Nederlands</option>
                                        <option value="en">English</option>
                                        <option value="de">Deutsch</option>
                                    </select>
                                </li>
                            </ul>
                        </div>

                        <button className="mobile-menu-button" onClick={() => this.setState({ mobileMenuOpen: !mobileMenuOpen })}>
                            <Hamburger />
                        </button>

                    </div>
                </section>
                <div className="header-dummy" />
            </React.Fragment>
        )
    }

}
